// extracted by mini-css-extract-plugin
export default {"courseAssign":"CourseAssign_courseAssign__WDaei"};